import { render } from "./ToU.vue?vue&type=template&id=4fe9df70"
import script from "./ToU.vue?vue&type=script&lang=js"
export * from "./ToU.vue?vue&type=script&lang=js"

import "./ToU.vue?vue&type=style&index=0&id=4fe9df70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__